import _classCallCheck from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/blainelewis/projects/blainelewis1.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isNumber, isString } from 'vega-util';
import { isMinMaxOp } from '../../aggregate';
import { getMainRangeChannel } from '../../channel';
import { isFieldDef, isFieldOrDatumDefForTimeFormat, isScaleFieldDef, isTypedFieldDef } from '../../channeldef';
import { isGenerator } from '../../data';
import { isDateTime } from '../../datetime';
import * as log from '../../log';
import { forEachLeaf } from '../../logical';
import { isPathMark } from '../../mark';
import { isFieldEqualPredicate, isFieldGTEPredicate, isFieldGTPredicate, isFieldLTEPredicate, isFieldLTPredicate, isFieldOneOfPredicate, isFieldPredicate, isFieldRangePredicate } from '../../predicate';
import { isSortField } from '../../sort';
import { accessPathDepth, accessPathWithDatum, duplicate, hash as _hash, keys, removePathFromField } from '../../util';
import { signalRefOrValue } from '../common';
import { isFacetModel, isUnitModel } from '../model';
import { Split } from '../split';
import { DataFlowNode } from './dataflow';
/**
 * Remove quotes from a string.
 */

function unquote(pattern) {
  if (pattern[0] === "'" && pattern[pattern.length - 1] === "'" || pattern[0] === '"' && pattern[pattern.length - 1] === '"') {
    return pattern.slice(1, -1);
  }

  return pattern;
}
/**
 * @param field The field.
 * @param parse What to parse the field as.
 */


function parseExpression(field, parse) {
  var f = accessPathWithDatum(field);

  if (parse === 'number') {
    return "toNumber(".concat(f, ")");
  } else if (parse === 'boolean') {
    return "toBoolean(".concat(f, ")");
  } else if (parse === 'string') {
    return "toString(".concat(f, ")");
  } else if (parse === 'date') {
    return "toDate(".concat(f, ")");
  } else if (parse === 'flatten') {
    return f;
  } else if (parse.startsWith('date:')) {
    var specifier = unquote(parse.slice(5, parse.length));
    return "timeParse(".concat(f, ",'").concat(specifier, "')");
  } else if (parse.startsWith('utc:')) {
    var _specifier = unquote(parse.slice(4, parse.length));

    return "utcParse(".concat(f, ",'").concat(_specifier, "')");
  } else {
    log.warn(log.message.unrecognizedParse(parse));
    return null;
  }
}

export function getImplicitFromFilterTransform(transform) {
  var implicit = {};
  forEachLeaf(transform.filter, function (filter) {
    var _a;

    if (isFieldPredicate(filter)) {
      // Automatically add a parse node for filters with filter objects
      var val = null; // For EqualFilter, just use the equal property.
      // For RangeFilter and OneOfFilter, all array members should have
      // the same type, so we only use the first one.

      if (isFieldEqualPredicate(filter)) {
        val = signalRefOrValue(filter.equal);
      } else if (isFieldLTEPredicate(filter)) {
        val = signalRefOrValue(filter.lte);
      } else if (isFieldLTPredicate(filter)) {
        val = signalRefOrValue(filter.lt);
      } else if (isFieldGTPredicate(filter)) {
        val = signalRefOrValue(filter.gt);
      } else if (isFieldGTEPredicate(filter)) {
        val = signalRefOrValue(filter.gte);
      } else if (isFieldRangePredicate(filter)) {
        val = filter.range[0];
      } else if (isFieldOneOfPredicate(filter)) {
        val = ((_a = filter.oneOf) !== null && _a !== void 0 ? _a : filter['in'])[0];
      } // else -- for filter expression, we can't infer anything


      if (val) {
        if (isDateTime(val)) {
          implicit[filter.field] = 'date';
        } else if (isNumber(val)) {
          implicit[filter.field] = 'number';
        } else if (isString(val)) {
          implicit[filter.field] = 'string';
        }
      }

      if (filter.timeUnit) {
        implicit[filter.field] = 'date';
      }
    }
  });
  return implicit;
}
/**
 * Creates a parse node for implicit parsing from a model and updates ancestorParse.
 */

export function getImplicitFromEncoding(model) {
  var implicit = {};

  function add(fieldDef) {
    if (isFieldOrDatumDefForTimeFormat(fieldDef)) {
      implicit[fieldDef.field] = 'date';
    } else if (fieldDef.type === 'quantitative' && isMinMaxOp(fieldDef.aggregate) // we need to parse numbers to support correct min and max
    ) {
      implicit[fieldDef.field] = 'number';
    } else if (accessPathDepth(fieldDef.field) > 1) {
      // For non-date/non-number (strings and booleans), derive a flattened field for a referenced nested field.
      // (Parsing numbers / dates already flattens numeric and temporal fields.)
      if (!(fieldDef.field in implicit)) {
        implicit[fieldDef.field] = 'flatten';
      }
    } else if (isScaleFieldDef(fieldDef) && isSortField(fieldDef.sort) && accessPathDepth(fieldDef.sort.field) > 1) {
      // Flatten fields that we sort by but that are not otherwise flattened.
      if (!(fieldDef.sort.field in implicit)) {
        implicit[fieldDef.sort.field] = 'flatten';
      }
    }
  }

  if (isUnitModel(model) || isFacetModel(model)) {
    // Parse encoded fields
    model.forEachFieldDef(function (fieldDef, channel) {
      if (isTypedFieldDef(fieldDef)) {
        add(fieldDef);
      } else {
        var mainChannel = getMainRangeChannel(channel);
        var mainFieldDef = model.fieldDef(mainChannel);
        add(Object.assign(Object.assign({}, fieldDef), {
          type: mainFieldDef.type
        }));
      }
    });
  } // Parse quantitative dimension fields of path marks as numbers so that we sort them correctly.


  if (isUnitModel(model)) {
    var mark = model.mark,
        markDef = model.markDef,
        encoding = model.encoding;

    if (isPathMark(mark) && // No need to sort by dimension if we have a connected scatterplot (order channel is present)
    !model.encoding.order) {
      var dimensionChannel = markDef.orient === 'horizontal' ? 'y' : 'x';
      var dimensionChannelDef = encoding[dimensionChannel];

      if (isFieldDef(dimensionChannelDef) && dimensionChannelDef.type === 'quantitative' && !(dimensionChannelDef.field in implicit)) {
        implicit[dimensionChannelDef.field] = 'number';
      }
    }
  }

  return implicit;
}
/**
 * Creates a parse node for implicit parsing from a model and updates ancestorParse.
 */

export function getImplicitFromSelection(model) {
  var implicit = {};

  if (isUnitModel(model) && model.component.selection) {
    var _iterator = _createForOfIteratorHelper(keys(model.component.selection)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;
        var selCmpt = model.component.selection[name];

        var _iterator2 = _createForOfIteratorHelper(selCmpt.project.items),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var proj = _step2.value;

            if (!proj.channel && accessPathDepth(proj.field) > 1) {
              implicit[proj.field] = 'flatten';
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return implicit;
}
export var ParseNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(ParseNode, _DataFlowNode);

  var _super = _createSuper(ParseNode);

  function ParseNode(parent, parse) {
    var _this;

    _classCallCheck(this, ParseNode);

    _this = _super.call(this, parent);
    _this._parse = parse;
    return _this;
  }

  _createClass(ParseNode, [{
    key: "clone",
    value: function clone() {
      return new ParseNode(null, duplicate(this._parse));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Parse ".concat(_hash(this._parse));
    }
    /**
     * Creates a parse node from a data.format.parse and updates ancestorParse.
     */

  }, {
    key: "parse",
    get: function get() {
      return this._parse;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      this._parse = Object.assign(Object.assign({}, this._parse), other.parse);
      other.remove();
    }
    /**
     * Assemble an object for Vega's format.parse property.
     */

  }, {
    key: "assembleFormatParse",
    value: function assembleFormatParse() {
      var formatParse = {};

      var _iterator3 = _createForOfIteratorHelper(keys(this._parse)),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var field = _step3.value;
          var p = this._parse[field];

          if (accessPathDepth(field) === 1) {
            formatParse[field] = p;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return formatParse;
    } // format parse depends and produces all fields in its parse

  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(keys(this._parse));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(keys(this._parse));
    }
  }, {
    key: "assembleTransforms",
    value: function assembleTransforms() {
      var _this2 = this;

      var onlyNested = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return keys(this._parse).filter(function (field) {
        return onlyNested ? accessPathDepth(field) > 1 : true;
      }).map(function (field) {
        var expr = parseExpression(field, _this2._parse[field]);

        if (!expr) {
          return null;
        }

        var formula = {
          type: 'formula',
          expr: expr,
          as: removePathFromField(field) // Vega output is always flattened

        };
        return formula;
      }).filter(function (t) {
        return t !== null;
      });
    }
  }], [{
    key: "makeExplicit",
    value: function makeExplicit(parent, model, ancestorParse) {
      // Custom parse
      var explicit = {};
      var data = model.data;

      if (!isGenerator(data) && data && data.format && data.format.parse) {
        explicit = data.format.parse;
      }

      return this.makeWithAncestors(parent, explicit, {}, ancestorParse);
    }
    /**
     * Creates a parse node from "explicit" parse and "implicit" parse and updates ancestorParse.
     */

  }, {
    key: "makeWithAncestors",
    value: function makeWithAncestors(parent, explicit, implicit, ancestorParse) {
      // We should not parse what has already been parsed in a parent (explicitly or implicitly) or what has been derived (maked as "derived"). We also don't need to flatten a field that has already been parsed.
      var _iterator4 = _createForOfIteratorHelper(keys(implicit)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var field = _step4.value;
          var parsedAs = ancestorParse.getWithExplicit(field);

          if (parsedAs.value !== undefined) {
            // We always ignore derived fields even if they are implicitly defined because we expect users to create the right types.
            if (parsedAs.explicit || parsedAs.value === implicit[field] || parsedAs.value === 'derived' || implicit[field] === 'flatten') {
              delete implicit[field];
            } else {
              log.warn(log.message.differentParse(field, implicit[field], parsedAs.value));
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(keys(explicit)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _field = _step5.value;

          var _parsedAs = ancestorParse.get(_field);

          if (_parsedAs !== undefined) {
            // Don't parse a field again if it has been parsed with the same type already.
            if (_parsedAs === explicit[_field]) {
              delete explicit[_field];
            } else {
              log.warn(log.message.differentParse(_field, explicit[_field], _parsedAs));
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var parse = new Split(explicit, implicit); // add the format parse from this model so that children don't parse the same field again

      ancestorParse.copyAll(parse); // copy only non-null parses

      var p = {};

      var _iterator6 = _createForOfIteratorHelper(keys(parse.combine())),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key = _step6.value;
          var val = parse.get(key);

          if (val !== null) {
            p[key] = val;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      if (keys(p).length === 0 || ancestorParse.parseNothing) {
        return null;
      }

      return new ParseNode(parent, p);
    }
  }]);

  return ParseNode;
}(DataFlowNode);